export const ANNOTATIONS = 'annotations';

export const INFO = 'info';
